import { legacy_createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
// import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './Reducer';

export const store = legacy_createStore(
    rootReducer,
    applyMiddleware(thunk)
    // composeWithDevTools(applyMiddleware(thunk))
);